import React from "react";
import ReactModal from "react-modal";
import "./style.scss";

export default function Modal({
  isOpen,
  onClose,
  onAfterClose,
  barIcon,
  children,
  innerClass = "",
  disableClose = false,
}) {
  return (
    <ReactModal
      isOpen={isOpen}
      onClose={onClose}
      onAfterClose={onAfterClose}
      overlayClassName={`modal-overlay ${innerClass}-overlay`}
      className={`modal-inner ${innerClass}-wrapper`}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={true}
      preventScroll={true}
      onRequestClose={onClose}
      appElement={document.getElementById("root")}
    >
      <div className="upper-bar">
        {!disableClose && (
          <button onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="black"
            >
              <path
                d="M18.75 5.25L5.25 18.75"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.75 18.75L5.25 5.25"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>
      <div className={`inner ${innerClass}`}>{children}</div>
    </ReactModal>
  );
}
